// Rejects when `promise` has not settled within `ms`. The underlying work is not cancelled — use it
// where a caller must move on regardless (e.g. logout teardown over a worker transport that awaits
// replies with no timeout of its own).
export const withTimeout = <T>(promise: Promise<T>, ms: number, label: string): Promise<T> =>
  new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      }
    );
  });
